// extracted by mini-css-extract-plugin
export var measureBox = "_4v-0";